import React, { Component } from "react";
import EmployeeListComponent from "../../components/Employees/EmployeeListComponent";

class EmployeeList extends Component {
  render() {
    return (
      <div>
        <EmployeeListComponent />
      </div>
    );
  }
}

export default EmployeeList;
